/**
 * Stable signatures for console modal "dirty" checks (runs + clubs).
 */

function fileFingerprint(file) {
  if (!file || typeof file !== "object") return null;
  if (typeof file.name !== "string") return null;
  return { n: file.name, z: file.size, m: file.lastModified };
}

/** Run create/edit modal image slots (kind url | pasted_url | file). */
export function serializeRunCarouselSlotsForDirty(slots) {
  if (!Array.isArray(slots)) return "[]";
  const parts = slots.map((s) => {
    if (!s || typeof s !== "object") return {};
    if (s.kind === "url" && s.url != null) return { k: "u", u: String(s.url) };
    if (s.kind === "pasted_url" && s.url != null) return { k: "p", u: String(s.url) };
    if (s.kind === "file" && s.file) {
      const fp = fileFingerprint(s.file);
      return fp ? { k: "f", ...fp } : { k: "f" };
    }
    return { k: String(s.kind ?? ""), id: s.id };
  });
  return JSON.stringify(parts);
}

/** Edit-club carousel slots (kind remote | pasted_url | file). */
export function serializeClubEditCarouselSlotsForDirty(slots) {
  if (!Array.isArray(slots)) return "[]";
  const parts = slots.map((s) => {
    if (!s || typeof s !== "object") return {};
    if (s.kind === "remote" && s.url != null) return { k: "r", u: String(s.url) };
    if (s.kind === "pasted_url" && s.url != null) return { k: "p", u: String(s.url) };
    if (s.kind === "file" && s.file) {
      const fp = fileFingerprint(s.file);
      return fp ? { k: "f", ...fp } : { k: "f" };
    }
    return { k: String(s.kind ?? ""), id: s.id };
  });
  return JSON.stringify(parts);
}

export function serializeFileArrayForDirty(files) {
  if (!Array.isArray(files) || files.length === 0) return "[]";
  return JSON.stringify(files.map((f) => fileFingerprint(f) || {}));
}

/** Onboard add-club: pasted image URL fields (hero / profile / carousel list). */
export function serializeAddClubPasteUrlsForDirty(heroPaste, profilePaste, carouselPastes) {
  const c = Array.isArray(carouselPastes) ? carouselPastes.map((x) => String(x ?? "").trim()) : [];
  return JSON.stringify({
    h: String(heroPaste ?? "").trim(),
    p: String(profilePaste ?? "").trim(),
    c,
  });
}
